'use client';

import { useEffect, useState } from 'react';

import { MagicTextInterface } from '~/payload-types';

import { cn } from '@/lib/utils';

type MagicTextProps = {} & MagicTextInterface;

export const MagicTextBlock: React.FC<MagicTextProps> = ({
  texts,
  typingSpeed,
  pauseDuration,
  loop = true,
  size,
}) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!texts || texts.length === 0) return;

    const currentText = texts[currentTextIndex];
    if (!currentText) return;

    const speed = parseInt(typingSpeed);
    const pauseTime = parseInt(pauseDuration);

    let timeout: NodeJS.Timeout;

    if (isTyping) {
      if (displayedText.length < currentText.text.length) {
        timeout = setTimeout(() => {
          setDisplayedText(currentText.text.slice(0, displayedText.length + 1));
        }, speed);
      } else {
        setIsTyping(false);
        setIsPaused(true);
        timeout = setTimeout(() => {
          setIsPaused(false);
          setIsTyping(false);
        }, pauseTime);
      }
    } else if (!isPaused) {
      if (displayedText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayedText(displayedText.slice(0, -1));
        }, speed);
      } else {
        setIsTyping(true);
        if (loop) {
          setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        } else if (currentTextIndex < texts.length - 1) {
          setCurrentTextIndex((prev) => prev + 1);
        }
      }
    }

    // return () => clearTimeout(timeout);
  }, [
    displayedText,
    isTyping,
    isPaused,
    currentTextIndex,
    texts,
    typingSpeed,
    pauseDuration,
    loop,
  ]);

  if (!texts || texts.length === 0) return null;

  const currentText = texts[currentTextIndex];
  if (!currentText) return null;

  return (
    <div
      className={cn('flex min-h-16 items-center justify-center')}
      style={{
        width: `${Math.max(...texts.map((t) => t.text.length)) * 3}ch`,
      }}
    >
      <span
        className={cn(
          'font-mono',
          currentText.color,
          'transition-colors duration-200',
          size,
        )}
      >
        {displayedText}
        <span className="animate-pulse">|</span>
      </span>
    </div>
  );
};
